export const WALLET_ADAPTER_CORE_VERSION = "4.11.1";
